/**
 * LSDN homepage signature cards — inline size selection with price + quick-buy sync.
 */
class LsdnSigCard extends HTMLElement {
  connectedCallback() {
    this.sizeButtons = Array.from(this.querySelectorAll('[data-lsdn-sig-size]'));
    this.priceContainer = this.querySelector('[data-lsdn-sig-price]');
    this.quickBuyModal = this.querySelector('quick-buy-modal');
    this.productHandle = this.dataset.productHandle;

    if (!this.sizeButtons.length || !this.priceContainer || !this.productHandle) {
      return;
    }

    this.templates = new Map(
      Array.from(this.querySelectorAll('template[data-lsdn-sig-price-template]')).map((template) => [
        template.dataset.lsdnSigPriceTemplate,
        template,
      ])
    );

    this.sizeButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectVariant(button.dataset.lsdnSigSize));
    });

    const defaultVariantId =
      this.dataset.defaultVariantId || this.sizeButtons.find((button) => button.dataset.lsdnSigSize)?.dataset.lsdnSigSize;

    if (defaultVariantId) {
      this.selectVariant(defaultVariantId, { focus: false });
    }
  }

  selectVariant(variantId, { focus = true } = {}) {
    if (!variantId) {
      return;
    }

    const template = this.templates.get(variantId);

    this.sizeButtons.forEach((button) => {
      const isSelected = button.dataset.lsdnSigSize === variantId;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (template) {
      this.priceContainer.innerHTML = template.innerHTML;
    }

    if (this.quickBuyModal) {
      this.quickBuyModal.setAttribute('handle', `${this.productHandle}?variant=${variantId}`);
    }

    this.dataset.selectedVariantId = variantId;

    if (focus) {
      this.sizeButtons.find((button) => button.dataset.lsdnSigSize === variantId)?.focus();
    }
  }
}

if (!customElements.get('lsdn-sig-card')) {
  customElements.define('lsdn-sig-card', LsdnSigCard);
}
